import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {filter, map} from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import {AccountService} from "../../services";
import {Notifications} from "../model/notifications";
import {Notification} from "../model/notification";

@Injectable({ providedIn: 'root' })
export class NotificationService {
    constructor(
        private router: Router,
        private http: HttpClient,
        private accountService: AccountService
    ) {

    }

    getAll(offset: number, limit: number) {

        return this.http.get<Notifications>(`${environment.apiEndpoint}/v1/notifications?offset=`+offset+`&limit=`+limit, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getById(id: string) {
        return this.http.get<Notification>(`${environment.apiEndpoint}/v1/notifications/${id}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    update(id, params) {
        return this.http.put(`${environment.apiEndpoint}/v1/notifications/${id}`, params, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }

    create(params) {
        return this.http.post(`${environment.apiEndpoint}/v1/notifications`, params, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }

    delete(id: string) {
        return this.http.delete(`${environment.apiEndpoint}/v1/notifications/` + id, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }
}
